import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { Eye, ArrowLeft } from 'lucide-react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ImpersonationBanner() {
  const { user, checkAuth } = useAuth();
  const { language } = useLanguage();
  const navigate = useNavigate();

  if (!user?.is_impersonated) return null;

  const handleStop = async () => {
    try {
      await axios.post(`${API}/admin/stop-impersonation`, {}, { withCredentials: true });
      await checkAuth();
      navigate('/admin');
    } catch (err) {
      console.error('Error stopping impersonation:', err);
    }
  };

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[100] bg-[#FF9500] text-white py-2 px-4 flex items-center justify-center gap-4 text-sm font-medium shadow-lg"
      data-testid="impersonation-banner"
    >
      <Eye className="h-4 w-4" />
      <span>
        {language === 'es'
          ? `Modo Admin — Viendo como: ${user.name} (${user.email})`
          : `Admin Mode — Viewing as: ${user.name} (${user.email})`}
      </span>
      <button
        onClick={handleStop}
        className="ml-4 px-3 py-1 bg-white/20 hover:bg-white/30 rounded-full text-xs font-semibold flex items-center gap-1 transition-colors"
        data-testid="stop-impersonation-btn"
      >
        <ArrowLeft className="h-3 w-3" />
        {language === 'es' ? 'Volver al Admin' : 'Back to Admin'}
      </button>
    </div>
  );
}
